<template>
  <div ref="roadTopRoot" class="top-section">
    <template v-if="lang !== 'ENG'">
      <h1 class="title d-none d-md-block">
        <span class="line"><span class="skinc-red-text">SK</span>가 나아가는 지속가능성의 길</span>
      </h1>
      <h1 class="title d-block d-md-none">
        <span class="line"><span class="skinc-red-text">SK</span>가 나아가는<br /></span>
        <span class="line">지속가능성의 길</span>
      </h1>
      <p class="description d-none d-md-block">
        <span class="line">지속가능한 미래를 위해 체계적인 ESG 경영을 실천하고 있습니다.</span>
      </p>
      <p class="description d-block d-md-none">
        <span class="line">지속가능한 미래를 위해 </span>
        <span class="line">체계적인 ESG 경영을 실천하고 있습니다.</span>
      </p>
    </template>

    <template v-else>
      <h1 class="title en-font d-none d-md-block">
        <span class="line"
          ><span class="skinc-red-text">SK</span>'s Path Toward Sustainability</span
        >
      </h1>
      <h1 class="title en-font d-block d-md-none">
        <span class="line"><span class="skinc-red-text">SK</span>'s Path <br /></span>
        <span class="line">Toward Sustainability</span>
      </h1>
      <p class="description en-font d-none d-md-block">
        <span class="line">Systematic ESG management is being </span>
        <span class="line">implemented to build a sustainable future.</span>
      </p>
      <p class="description en-font d-block d-md-none">
        <span class="line">Systematic ESG management</span>
        <span class="line">is being implemented to</span>
        <span class="line">build a sustainable future.</span>
      </p>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'TopSection',
  computed: {
    ...mapState('report_list', ['lang'])
  },
  data() {
    return {
      observer: null
    };
  },
  mounted() {
    const options = {
      rootMargin: '-20% 0px 0px 0px',
      threshold: 0.2
    };

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else {
          entry.target.classList.remove('is-visible');
        }
      });
    }, options);

    this.observer.observe(this.$refs.roadTopRoot);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style scoped>
.top-section {
  text-align: center;
  margin-bottom: 60px;
}

.title,
.description {
  overflow: hidden;
  padding: 5px 0;
}

.title {
  text-align: center;
  font-size: clamp(36px, 5vw, 76px);
  line-height: 1.2;
  font-weight: bold;
  color: #000;
  margin-bottom: 24px;
}

.description {
  text-align: center;
  font-size: clamp(16px, 2.5vw, 28px);
  color: #4b4b4b;
  line-height: 1.6;
}

.title.en-font {
  font-size: clamp(28.8px, 4vw, 60.8px);
}

.description.en-font {
  font-size: clamp(13px, 2vw, 22.4px);
}

.line {
  display: block;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.top-section.is-visible .line {
  opacity: 1;
  transform: translateY(0);
}

.top-section.is-visible .d-md-block.title .line {
  transition-delay: 0.2s;
}
.top-section.is-visible .d-md-block.description .line:nth-child(1) {
  transition-delay: 0.4s;
}
.top-section.is-visible .d-md-block.description .line:nth-child(2) {
  transition-delay: 0.6s;
}

.top-section.is-visible .d-md-none.title .line:nth-child(1) {
  transition-delay: 0.2s;
}
.top-section.is-visible .d-md-none.title .line:nth-child(2) {
  transition-delay: 0.4s;
}
.top-section.is-visible .d-md-none.description .line:nth-child(1) {
  transition-delay: 0.6s;
}
.top-section.is-visible .d-md-none.description .line:nth-child(2) {
  transition-delay: 0.8s;
}
.top-section.is-visible .d-md-none.description .line:nth-child(3) {
  transition-delay: 1s;
}
</style>
